// src/components/CacheStatus.js
import React, { useEffect, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';

const CacheStatus = () => {
    const queryClient = useQueryClient();
    const [cacheEntries, setCacheEntries] = useState([]);

    useEffect(() => {
        // Mise à jour périodique de l'état du cache
        const updateCacheStatus = () => {
            const queries = queryClient.getQueryCache().findAll();
            setCacheEntries(queries.map(query => ({
                key: JSON.stringify(query.queryKey),
                state: query.state.status,
                lastUpdated: new Date(query.state.dataUpdatedAt).toLocaleTimeString()
            })));
        };

        updateCacheStatus();
        const interval = setInterval(updateCacheStatus, 2000);

        return () => clearInterval(interval);
    }, [queryClient]);

    if (process.env.NODE_ENV !== 'development') return null;

    return (
        <div style={{
            position: 'fixed',
            bottom: 10,
            left: 10,
            background: 'rgba(255, 255, 255, 0.9)',
            padding: '10px',
            borderRadius: '5px',
            boxShadow: '0 0 10px rgba(0,0,0,0.1)',
            zIndex: 9999,
            maxHeight: '300px',
            overflow: 'auto',
            fontSize: '12px'
        }}>
            <h4 style={{ margin: '0 0 10px' }}>Cache Status</h4>
            <table style={{ borderCollapse: 'collapse' }}>
                <thead>
                    <tr>
                        <th style={{ padding: '5px', textAlign: 'left' }}>Key</th>
                        <th style={{ padding: '5px', textAlign: 'left' }}>Status</th>
                        <th style={{ padding: '5px', textAlign: 'left' }}>Last Updated</th>
                    </tr>
                </thead>
                <tbody>
                    {cacheEntries.map((entry, i) => (
                        <tr key={i}>
                            <td style={{ padding: '5px', borderTop: '1px solid #eee' }}>{entry.key}</td>
                            <td style={{ padding: '5px', borderTop: '1px solid #eee' }}>{entry.state}</td>
                            <td style={{ padding: '5px', borderTop: '1px solid #eee' }}>{entry.lastUpdated}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {cacheEntries.length === 0 && <p>No cache entries found</p>}
        </div>
    );
};

export default CacheStatus;